import { Avatar, Divider, IconButton, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { TrashCan, TrashCanDark, WatchFile, WatchFileDark } from 'Images';
import { isDesktop } from 'react-device-detect';

interface IFileActions {
  filename: string;
  watchFile: () => void;
  deleteFile: () => void;
}

export const FileActions = (props: IFileActions) => {
  const dictionary = Dictionary[DICTIONARY.General];
  return (
    <Stack
      sx={{
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: isDesktop ? 'end' : 'space-between',
        alignSelf: isDesktop ? undefined : 'self-end',
        mt: 2,
        mb: 1,
        width: isDesktop ? undefined : 'unset',
      }}
    >
      <Stack
        onClick={props.watchFile}
        sx={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          maxWidth: isDesktop ? '100px' : '80px',
          position: 'relative',
          left: isDesktop ? '-5px' : '-12px',
        }}
      >
        <IconButton
          sx={{
            padding: '4px',
          }}
        >
          <Avatar
            src={WatchFileDark}
            alt={`${dictionary.watch} ${props.filename}`}
            sx={{ width: '24px', height: '24px' }}
          />
        </IconButton>
        <Typography variant='body6' noWrap sx={{ cursor: 'pointer' }}>
          {dictionary.watch}
          <span className='sr-only'>{props.filename}</span>
        </Typography>
      </Stack>

      <Divider
        aria-hidden='true'
        orientation='vertical'
        flexItem
        variant='middle'
        sx={{ position: 'relative', left: isDesktop ? '-5px' : undefined }}
      />
      <Stack
        onClick={props.deleteFile}
        sx={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          maxWidth: isDesktop ? '110px' : '80px',
          position: 'relative',
          right: isDesktop ? undefined : '-20px',
        }}
      >
        <IconButton
          sx={{
            padding: '4px',
          }}
        >
          <Avatar
            src={TrashCanDark}
            sx={{ width: '24px', height: '24px' }}
            alt={`${dictionary.deleteFile} ${props.filename}`}
          />
        </IconButton>
        <Typography
          variant='body6'
          sx={{ cursor: 'pointer', minWidth: '85px' }}
        >
          {isDesktop ? dictionary.deleteFile : dictionary.delete}
          <span className='sr-only'>{props.filename}</span>
        </Typography>
      </Stack>
    </Stack>
  );
};
